import { createContext, useContext } from 'react'
import type { ToastInfoType } from '@trinity/utils'

export interface GlobalContextValue {
  setToastInfo: React.Dispatch<React.SetStateAction<ToastInfoType>>
  onMobile: boolean
  onTablet: boolean
  onLaptop: boolean
  onDesktop: boolean
  onSkiffle: boolean
  user: TrinityAPI.LoginType
}

export const GlobalContext = createContext<GlobalContextValue | null>(null)
GlobalContext.displayName = 'GlobalContext'

export function useGlobalState() {
  const globalContext = useContext(GlobalContext)

  if (globalContext === null) {
    throw new Error('useGlobalState must be used within a GlobalProvider')
  }

  return globalContext
}
